import { buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import type { VariantProps } from 'class-variance-authority'
import Link from 'next/link'
import type { ComponentProps } from 'react'

interface LinkButtonProps
  extends ComponentProps<typeof Link>,
    VariantProps<typeof buttonVariants> {
  className?: string
}

/**
 * LinkButton component that combines Next.js Link with Button styling
 * Provides optimal performance with prefetching and instant navigation
 */
export const LinkButton = ({
  href,
  variant = 'default',
  size = 'default',
  className,
  children,
  prefetch = true,
  ...props
}: LinkButtonProps) => {
  return (
    <Link
      href={href}
      prefetch={prefetch}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    >
      {children}
    </Link>
  )
} 